import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { MailTrackingInfo } from './types';

interface MailTrackingSummaryProps {
    mailTracking: MailTrackingInfo[];
    keywordCount: number;
}

const MailTrackingSummary: React.FC<MailTrackingSummaryProps> = ({ mailTracking, keywordCount }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border">
            <div className="px-6 py-4 border-b border-gray-200">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-gray-900">Mail Takip</h2>
                    <div className="flex items-center space-x-3 text-sm text-gray-500">
                        <span>Aktif keyword: {keywordCount}</span>
                        <Mail className="h-5 w-5 text-gray-400" />
                    </div>
                </div>
            </div>
            <div className="px-6 py-6">
                {mailTracking.length > 0 ? (
                    <div className="space-y-4">
                        {mailTracking.slice(0, 5).map((track) => (
                            <div key={track.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                                <div className="flex items-center space-x-3">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                        <Mail className="h-5 w-5 text-blue-600" />
                                    </div>
                                    <div>
                                        <p className="font-medium text-gray-900">{track.name}</p>
                                        <p className="text-sm text-gray-500 break-all">
                                            {track.pattern}
                                        </p>
                                        {track.description && (
                                            <p className="text-xs text-gray-400 mt-1">{track.description}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="text-right whitespace-nowrap ml-4">
                                    <p className="text-xs text-gray-500">
                                        Güncellendi: {new Date(track.updatedAt).toLocaleDateString('tr-TR')}
                                    </p>
                                </div>
                            </div>
                        ))}
                        {mailTracking.length > 5 && (
                            <div className="text-center pt-2">
                                <Link
                                    to="/mail-tracking"
                                    className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                                >
                                    Tümünü Gör ({mailTracking.length} keyword)
                                </Link>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="text-center text-gray-500">
                        <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-4">
                            <Mail className="h-8 w-8 text-gray-400" />
                        </div>
                        <p className="text-lg font-medium text-gray-900 mb-2">Henüz keyword tanımlanmamış</p>
                        <p className="text-sm text-gray-600 leading-relaxed mb-4">
                            Mail takibi için önce keyword'ler tanımlayın.
                        </p>
                        <Link
                            to="/mail-tracking"
                            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
                        >
                            <Mail className="h-4 w-4 mr-2" />
                            Keyword Tanımla
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MailTrackingSummary;
